import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MessageSocketState {
  isConnected: boolean;
  isConnecting: boolean;
  connectionError: string | null;
  reconnectAttempts: number;
}

const initialState: MessageSocketState = {
  isConnected: false,
  isConnecting: false,
  connectionError: null,
  reconnectAttempts: 0,
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    messageSocketConnecting: (state) => {
      state.isConnecting = true;
      state.connectionError = null;
    },
    messageSocketConnected: (state) => {
      state.isConnected = true;
      state.isConnecting = false;
      state.connectionError = null;
      state.reconnectAttempts = 0;
    },
    messageSocketDisconnected: (state) => {
      state.isConnected = false;
      state.isConnecting = false;
    },
    messageSocketError: (state, action: PayloadAction<string>) => {
      state.isConnected = false;
      state.isConnecting = false;
      state.connectionError = action.payload;
    },
    messageSocketReconnectAttempt: (state) => {
      state.reconnectAttempts += 1;
    },
    resetMessageSocketState: (state) => {
      state.isConnected = false;
      state.isConnecting = false;
      state.connectionError = null;
      state.reconnectAttempts = 0;
    },
  },
});

export const {
  messageSocketConnecting,
  messageSocketConnected,
  messageSocketDisconnected,
  messageSocketError,
  messageSocketReconnectAttempt,
  resetMessageSocketState,
} = messageSlice.actions;

export default messageSlice.reducer;
